import React from 'react';
import { Container, Grid, Card, CardMedia, CardContent, CardActions, Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import hamRadioImage from '../images/ham_radio.jpg';
import softwareDevImage from '../images/software_dev.jpg';

// Add new applications here as they're built. Set `external: true` for
// links that leave the site (e.g. a hosted app or app store listing).
const applications = [
    {
        name: 'APRS Chat',
        description: 'A chat platform for group and individual messaging through traditional APRS infrastructure.',
        image: hamRadioImage,
        linkTo: '/software',
        linkText: 'View Downloads',
        external: false,
    },
    {
        name: 'New Application',
        description: 'Details coming soon.',
        image: softwareDevImage,
        linkTo: '#',
        linkText: 'Coming Soon',
        external: false,
        disabled: true,
    },
];

const Applications = () => {
    return (
        <Container maxWidth="lg">
            <Typography variant="h4" component="h1" gutterBottom>
                Applications
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 5 }}>
                A collection of applications Jordan has built and maintains.
            </Typography>
            <Grid container spacing={3}>
                {applications.map((app) => (
                    <Grid size={{ xs: 12, md: 6, lg: 4 }} key={app.name}>
                        <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                            <CardMedia component="img" height="200" image={app.image} alt={app.name} />
                            <CardContent sx={{ flex: 1 }}>
                                <Typography variant="h6" component="h2" gutterBottom>
                                    {app.name}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {app.description}
                                </Typography>
                            </CardContent>
                            <CardActions sx={{ p: 2, pt: 0 }}>
                                {app.external ? (
                                    <Button
                                        variant="contained"
                                        fullWidth
                                        href={app.linkTo}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        disabled={app.disabled}
                                    >
                                        {app.linkText}
                                    </Button>
                                ) : (
                                    <Button
                                        variant="contained"
                                        fullWidth
                                        component={Link}
                                        to={app.linkTo}
                                        disabled={app.disabled}
                                    >
                                        {app.linkText}
                                    </Button>
                                )}
                            </CardActions>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};

export default Applications;
